import { useEffect } from 'react';

import UXFeedback from 'utils/uxfeedback/utils';

import { Cookies } from '@hh.ru/browser-api-utils';

import { selectShouldSendUXFBEvent, setShouldSendUXFBEvent } from 'store/autoReducers';
import { useDispatch, useSelector } from 'store/utils';

const UXFB_SEND_EVENT_DELAY = 3000;
const WEEK_IN_HOURS = 24 * 7;

const useSendUXFBEvent = (event: string): void => {
    // https://uxfeedback.atlassian.net/wiki/spaces/UXFBBZ/pages/154337825/Widget.js#Код-события-с-задержкой
    const shouldSendUXFBEvent = useSelector(selectShouldSendUXFBEvent);
    const dispatch = useDispatch();
    const cookie = Cookies.get(`uxfeedback_${event}`);

    useEffect(() => {
        if (shouldSendUXFBEvent && !cookie) {
            setTimeout(() => {
                UXFeedback.sendEvent(event);
                Cookies.set(`uxfeedback_${event}`, 'true', WEEK_IN_HOURS);
            }, UXFB_SEND_EVENT_DELAY);
        }
        dispatch(setShouldSendUXFBEvent(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldSendUXFBEvent, dispatch, event]);
};

export default useSendUXFBEvent;
